export const roRO = {
  app: {
    categories: {
      convectors: 'Convectoare',
      decorative: 'Decorative',
      electric: 'Electrice',
      panels: 'Panou',
      towel: 'Port prosop',
    },
    categoryLabel: 'Categorie',
    categoryPlaceholder: 'Selectați o categorie',
    errorCategories: 'Nu s-au putut încărca categoriile.',
    errorPanels: 'Nu s-au putut încărca radiatoarele.',
    loadingCategories: 'Se încarcă categoriile...',
    loadingPanels: 'Se încarcă radiatoarele...',
    panelLabel: 'Radiatoare',
    panelPlaceholder: 'Selectați un radiator',
    titles: {
      convectors: 'Calculator convectoare',
      decorative: 'Calculator radiatoare decorative',
      electric: 'Calculator radiatoare electrice',
      panels: 'Calculator radiatoare panou',
      towel: 'Calculator radiatoare port prosop',
    },
  },
  calc: {
    actionButton: 'Afișează produsele calculate',
    boost: 'Mod boost',
    calculateRequiredButton: 'Calculează puterea necesară',
    calculating: 'Se calculează...',
    comfort: 'Mod confort',
    downloadLabel: 'Descarcă date ({count})',
    emptyResults: 'Niciun rezultat încă.',
    errorMatch: 'Nu s-au putut calcula rezultatele.',
    errorTypes: 'Nu s-au putut încărca tipurile de radiatoare.',
    flowTemp: 'Temperatură tur C°',
    height: 'Înălțime',
    length: 'Lungime',
    loadingTypes: 'Se încarcă tipurile...',
    modeLabel: 'Mod',
    modes: {
      cooling: 'Răcire',
      heating: 'Încălzire',
    },
    radiatorType: 'Tip radiator',
    requiredWatts: 'Putere necesară (W)',
    resultsMessage: '{count} produse disponibile pentru opțiunile selectate.',
    returnTemp: 'Temperatură retur C°',
    roomTemp: 'Temperatura camerei C°',
    selectAllLabel: 'Selectați toate produsele',
    selectItemLabel: 'Selectați produsul pentru descărcare',
    selectPanel: 'Selectați un radiator pentru calcul.',
    standby: 'Mod standby',
    tableHeaders: {
      calculatedWattage: 'Putere',
      co2Equivalent: 'Echivalent CO2 per kg de material',
      depth: 'Adâncime [mm]',
      description: 'Descriere produs',
      dop: 'DoP',
      eudop: 'EU DoP',
      height: 'Înălțime [mm]',
      itemId: 'Cod produs',
      length: 'Lungime [mm]',
      waterContent: 'Conținut apă',
      weight: 'Greutate',
    },
    title: 'Calcule',
    tolerance: 'Toleranță',
    typeCooling: 'Răcire',
    typeGroupLabel: 'Tip',
    typeHeating: 'Încălzire',
  },
  existingRadiator: {
    description:
      'Acest calculator este doar orientativ. Consultați întotdeauna un instalator profesionist pentru calculul exact înainte de achiziționarea radiatorului.',
    height: 'Înălțime radiator',
    length: 'Lungime radiator',
    resultLabelTemplate: 'Necesar putere termică, calculat la {temp} temperatură sistem',
    select: 'Selectați',
    temperature: 'Temperatura sistemului',
    type: 'Tip radiator',
  },
  matrixCalc: {
    axisHeight: 'Înălțime (mm)',
    axisLength: 'Lungime (mm)',
    axisType: 'Tip',
    calculateButton: 'Calculate',
    displayLabel: 'Afișare',
    exportExcel: 'Exportă în Excel',
    exportPdf: 'Exportă în PDF',
    print: 'Printează',
    hideOutOfRange: 'Ascunde articolele din afara intervalului',
    showAll: 'Afișează tot',
    loading: 'Loading...',
    lockHeight: 'Înălțime',
    lockLabel: 'Blochează dimensiunea',
    lockLength: 'Lungime',
    lockType: 'Tip',
    noData: 'Select a radiator and click Calculate to view the matrix.',
    noItem: '—',
    noType: '—',
    targetOutput: 'Target output (W)',
    title: 'Matrix Calculator',
    tolerance: 'Tolerance (%)',
  },
  roomCalc: {
    actionButton: 'Calculează',
    clearButton: 'Șterge tot',
    fields: {
      ceilingHeight: 'Înălțime tavan',
      doorInsulation: 'Izolație ușă',
      floorInsulation: 'Izolație podea',
      glazingArea: 'Suprafață geamuri',
      glazingMode: 'Suprafață geamuri',
      glazingQuality: 'Calitate geamuri',
      length: 'Lungime',
      outerWalls: 'Pereți exteriori',
      projectedDesignTemp: 'Temperatura exterioară de proiectare',
      roofInsulation: 'Izolație acoperiș',
      roomArea: 'Suprafață cameră',
      roomFloor: 'Etaj',
      roomInsulation: 'Izolație cameră',
      roomPreset: 'Tip cameră',
      roomTemperature: 'Temperatura camerei',
      roomType: 'Tip cameră',
      uncertaintyFactor: 'Factor de incertitudine',
      ventilation: 'Nivel ventilație',
      wallInsulation: 'Izolație pereți',
      width: 'Lățime',
      windConditions: 'Condiții de vânt',
      windowInsulation: 'Izolație ferestre',
    },
    intro:
      'Calculați pierderile de căldură din cameră pentru a selecta produsul potrivit din gama noastră de radiatoare.',
    options: {
      glazing: {
        m2: 'm²',
        percent: '%',
      },
      glazingBands: {
        high: 'Mai mult de 20%',
        low: 'Mai puțin de 10%',
        mid: '10-20%',
      },
      glazingValue: {
        above_20: 'Peste 20%',
        below_10: 'Sub 10%',
        from_10_to_20: 'De la 10% la 20%',
        no_windows: 'Fără ferestre',
      },
      insulationValue: {
        good: 'Bună',
        medium: 'Medie',
        poor: 'Slabă',
        very_good: 'Foarte bună',
      },
      qualityValue: {
        modern_excellent: 'Moderne, eficiență energetică excelentă',
        modern_good: 'Moderne, eficiență energetică bună',
        old_poor: 'Vechi, eficiență energetică foarte slabă',
        traditional_medium: 'Tradiționale, eficiență energetică medie',
      },
      roomValue: {
        bathroom_24: 'Baie (24 C°)',
        bedroom_20: 'Dormitor (22 C°)',
        garage_12: 'Garaj (10 C°)',
        livingroom_22: 'Living (22 C°)',
        storage_16: 'Depozit (15 C°)',
        extra_1: 'Bucătărie (20 C°)',
        extra_2: 'Hol (20 C°)',
        extra_3: 'Grup sanitar (20 C°)',
      },
      select: 'Selectați',
      storeyValue: {
        ground_multi: 'Parter (clădire cu mai multe etaje)',
        ground_single: 'Parter (clădire cu un etaj)',
        interim: 'Etaj intermediar',
        top_multi: 'Ultimul etaj (clădire cu mai multe etaje)',
      },
      temp: {
        climate_zone_1: 'Temp. proiect. -12 C°',
        climate_zone_2: 'Temp. proiect. -14 C°',
        climate_zone_3: 'Temp. proiect. -16 C°',
        climate_zone_4: 'Temp. proiect. -18 C°',
        climate_zone_5: 'Temp. proiect. -20 C°',
        climate_zone_6: 'Temp. proiect. -22 C°',
        climate_zone_7: 'Temp. proiect. -24 C°',
        climate_zone_8: 'Temp. proiect. -26 C°',
      },
      windInfluence: {
        normal: 'Normal',
        strong: 'Puternic',
        weak: 'Slab',
      },
    },
    roomPresets: {
      bathroom: 'Baie',
      bedroom: 'Dormitor',
      garage: 'Garaj',
      kitchen: 'Bucătărie',
      living: 'Living',
      storage: 'Depozit',
    },
    sections: {
      dimensions: 'Dimensiuni cameră',
      insulation: 'Izolație',
      placement: 'Amplasare',
      result: 'Rezultat',
      temps: 'Temperaturi',
      ventilation: 'Ventilație',
    },
    title: 'Calculator pierderi de căldură cameră',
    units: {
      celsius: 'C°',
      meter: 'm',
      percent: '%',
      squareMeter: 'm²',
      watts: 'W',
    },
    useButton: 'Folosește',
  },
  slider: {
    from: 'De la',
    to: 'La',
    value: 'Valoare',
  },
}
